export default "__VITE_ASSET__BoEghjbJ__"